import type { AlineSelection, RenderModelLine } from '@aline/common';
import { isRenderModelParagraph, lineDimensions } from '@aline/common';
import type { Editor, NodeEntry } from 'slate';

import { Queries } from '.';

export const locationQueries = {
  /**
   * Utility function for determining the width to the focus.
   */
  getWidthToFocus(editor: Editor, rMLineEntry: NodeEntry<RenderModelLine>): number {
    const [rMFocusLine, rMFocusLinePath] = rMLineEntry;

    const rMParaEntry = Queries.renderModelAbove(editor, {
      at: rMFocusLinePath,
      match: isRenderModelParagraph,
    });
    if (!rMParaEntry) throw new Error('Expected paragraph');
    const [rMFocusPara, rMFocusParaPath] = rMParaEntry;

    // Const this out to get type safety on moveVertWidth.
    const alineSel: AlineSelection | null = editor.selection;
    const cMParagraphPath = Queries.getCMPathFromRMPath(editor, rMFocusParaPath);
    if (!alineSel) return 0;

    const { from: relWidthToFocus } = lineDimensions(editor, {
      cMParaPath: cMParagraphPath,
      rMLine: rMFocusLine,
      rMPara: rMFocusPara,
      spanOptions: {
        from: alineSel.focus,
      },
    });
    const lineLeftEdgePx = Queries.getLineLeftEdgePx(editor, [rMFocusLine, rMFocusLinePath]);

    return alineSel.moveVertWidth ?? lineLeftEdgePx + relWidthToFocus;
  },
};
